import { render, staticRenderFns } from "./originality.vue?vue&type=template&id=930f80da&scoped=true&"
import script from "./originality.vue?vue&type=script&lang=js&"
export * from "./originality.vue?vue&type=script&lang=js&"
import style0 from "./originality.vue?vue&type=style&index=0&id=930f80da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930f80da",
  null
  
)

export default component.exports